import { ConfigServiceProvider } from '../config-service/config-service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StorageServiceProvider } from '../storage-service/storage-service';
import { TextServiceProvider } from '../text-service/text-service';

@Injectable()
export class LayoutServiceProvider {
  private _layout = null;
  private _states = {};
  private _layoutType = 'default';
  private _menu = [];
  private _pages: Array<any> = [];
  public layoutUrl = '../../../../assets/layout/layout.json';

  constructor(
    private http: HttpClient,
    private storageService: StorageServiceProvider,
    public configService: ConfigServiceProvider,
    public textService: TextServiceProvider,
  ) {}

  load() {
    return new Promise<void>((resolve, reject) => {
      this.http
        .get(this.configService.getUrl('layout'))
        // .get(this.layoutUrl)
        .toPromise()
        .then(
          (response: any) => {
            this._layout = response.params;
            return this.storageService.setObject('layout', this._layout);
          },
          (error) => reject(error),
        )
        .then(
          () => resolve(),
          (error) => reject(error),
        );
    });
  }

  loadLocal() {
    return new Promise<void>((resolve, reject) => {
      this.storageService.getObject('layout').then(
        (response: any) => {
          this.layout = response;
          resolve();
        },
        (error) => reject(error),
      );
    });
  }

  get menu() {
    return this._menu;
  }

  set menu(value: any[]) {
    this._menu = value;
  }

  get layout(): any[] {
    return this._layout;
  }

  set layout(value: any[]) {
    this._layout = value;
  }

  getState(state) {
    return this._states[state] || null;
  }

  setIcon(view) {
    view.icon = this.textService.get('icon' + view.title) ? this.textService.get('icon' + view.title) : view.icon;
    return view;
  }

  setTitle(view) {
    view.title = this.textService.get('menu' + view.title) ? this.textService.get('menu' + view.title) : view.title;
    return view;
  }

  async prepareMenuToDisplay() {
    this.menu.forEach((item) => {
      item = this.setIcon(item);
      item = this.setTitle(item);
      if (item.type === 'TABS') {
        item.content.tabs.forEach((view) => {
          view = this.setIcon(view);
          this.setTitle(view);
        });
      }
    });
  }

  async setLayoutType(type: string) {
    if (type) {
      this._layoutType = type;
    }

    let layoutConfiguration = this._layout[this.layoutType] || this._layout['default'];
    this.menu = layoutConfiguration.layout;
    this.pages = layoutConfiguration.page;
    await this.prepareMenuToDisplay();
  }

  get pages(): Array<any> {
    return this._pages;
  }

  set pages(value: Array<any>) {
    this._pages = value;
  }

  get states(): {} {
    return this._states;
  }

  set states(value: {}) {
    this._states = value;
  }

  get layoutType(): string {
    return this._layoutType;
  }

  set layoutType(value: string) {
    this._layoutType = value;
  }

  getViewFromPages(id: string): any {
    return this.pages[id];
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/layout-service/layout-service.ts